<script>
  /** @type {{children?: import('svelte').Snippet}} */
  let { children } = $props();
</script>

<div
  class="bg-white dark:bg-gray-800 rounded-2xl p-8 transform transition duration-500 hover:scale-105 hover:shadow-xl border border-gray-200 dark:border-gray-700"
>
  {@render children?.()}
</div>
